import type { NormalizedEvent } from "@/services/types/agent-gateway";

const USER_AUTHORS = new Set(["human", "user"]);

export function deduplicateEvents(events: NormalizedEvent[]) {
  const seen = new Set<string>();

  return events.filter((event) => {
    if (seen.has(event.id)) {
      return false;
    }

    seen.add(event.id);
    return true;
  });
}

export function isUserAuthor(author: string) {
  return USER_AUTHORS.has(author.trim().toLowerCase());
}

export function getParticipatingAgentCount(events: NormalizedEvent[]) {
  return new Set(
    events
      .map((event) => event.author.trim())
      .filter((author) => author && !isUserAuthor(author)),
  ).size;
}

export function formatEventAuthor(author: string) {
  if (isUserAuthor(author)) {
    return "You";
  }

  const formatted = author
    .trim()
    .replace(/[_-]+/g, " ")
    .replace(/\b\w/g, (letter) => letter.toUpperCase());

  return formatted || "Agent";
}

export function formatEventStatus(status: string) {
  const formatted = status
    .trim()
    .replace(/[_-]+/g, " ")
    .replace(/\b\w/g, (letter) => letter.toUpperCase());

  return formatted || "Unknown";
}

export function formatEventTime(value: string | null) {
  if (!value) {
    return "Time unavailable";
  }

  return new Intl.DateTimeFormat("en-US", {
    hour: "numeric",
    minute: "2-digit",
  }).format(new Date(value));
}
